<div *ngIf="!dataLoading">
    <div class="top-margin-10">
        <p class="headingrow bottom-padding-5 margin-5"><span class="bold headingtext">Person Information</span></p>
        <div class="row bottom-margin-0">
            <div class="col s12 m2 l2 xl2"><span class="bold">First Name:</span> {{personInfo?.firstName}}</div>
            <div class="col s12 m2 l1 xl1"><span class="bold">MI:</span> {{personInfo?.mi}}</div>
            <div class="col s12 m2 l2 xl2"><span class="bold">Last Name:</span> {{personInfo?.lastName}}</div>
            <div class="col s12 m2 l2 xl2"><span class="bold">DOB:</span> {{personInfo?.dateOfBirth | date:
                'MM/dd/yyyy'}}</div>
            <div class="col s12 m2 l2 xl2"><span class="bold">Gender:</span> {{personInfo?.gender}}</div>
        </div>
    </div>
    <div class="top-margin-10">
        <p class="headingrow bottom-padding-5 margin-5"><span class="bold headingtext">Enrollment Information</span></p>
        <div class="row bottom-margin-0">
            <div class="col s12 m12 l12 xl12"><span class="bold">{{config.Question1}}</span>
                {{enrollmentInfo?.electType}}</div>
            <div class="col s12 m12 l12 xl12" *ngIf="enrollmentInfo?.electType === 'No'"><span
                    class="bold">{{config.NoSelectionMsg}}</span>
                {{enrollmentInfo?.positionType}}</div>
            <div class="col s12 m12 l12 xl12" *ngIf="enrollmentInfo?.positionType === 'Yes'"><span
                    class="bold">Employment Start Date:</span>
                {{enrollmentInfo?.enrollmentDate | date:'MM/dd/yyyy'}}</div>
            <div class="col s12 m12 l12 xl12" *ngIf="enrollmentInfo?.positionType === 'Yes'"><span
                    class="bold">Location:</span>
                {{enrollmentInfo?.locationName?.name}}</div>
            <div class="col s12 m12 l12 xl12" *ngIf="enrollmentInfo?.positionType === 'Yes'">
                <span class="bold">System:</span>
                {{enrollmentInfo?.systemName?.description}}
            </div>
            <div class="col s12 m12 l12 xl12" *ngIf="enrollmentInfo?.positionType === 'Yes'">
                <span class="bold">Pay Schedule Id:</span>
                {{enrollmentInfo?.payScheduleId}}
            </div>
            <div class="col s12 m12 l12 xl12" *ngIf="enrollmentInfo?.positionType === 'Yes'">
                <div *ngIf="enrollmentInfo?.uploadedFileName !== null"><span class="bold">Job
                        Description:</span>
                    {{enrollmentInfo?.uploadedFileName}}</div>
                <div *ngIf="enrollmentInfo?.tenMonthEmpType !== ''"><span class="bold">{{config.Question3}}</span>
                    {{enrollmentInfo?.tenMonthEmpType}}</div>
            </div>
        </div>
    </div>
    <div class="top-margin-10" *ngIf="contactInfo !== null">
        <p class="headingrow bottom-padding-5 margin-5"><span class="bold headingtext">Contact Information</span></p>
        <div class="row bottom-margin-0">
            <div class="col s12 m12 l12 xl12">
                <div class="col s12 m12 l6 xl5 left-padding-0"><span class="bold">Proof of Birth:</span>
                    {{contactInfo?.proofOfBirthType}}</div>
                <div class="col s12 m12 l5 xl5 left-padding-0"><span class="bold">Customer Identifier:</span>
                    {{contactInfo?.customerIdentifierNo}}</div>
            </div>
            <div class="col s12 m12 l12 xl12">
                <div class="col s12 m12 l5 xl5 left-padding-0"><span class="bold">Address1:</span>
                    {{contactInfo?.addressLine1}}</div>
                <div class="col s12 m12 l4 xl4 left-padding-0"><span class="bold">Address2:</span>
                    {{contactInfo?.addressLine2}}</div>
                <div class="col s12 m12 l2 xl2 left-padding-0"><span class="bold">City:</span> {{contactInfo?.city}}
                </div>
            </div>
            <div>
                <div class="col s12 m12 l6 xl5"><span class="bold">State:</span> {{contactInfo?.state}}</div>
                <div class="col s12 m12 l6 xl5 left-padding-0"><span class="bold">Zip:</span> {{contactInfo?.zip}}</div>
                <div class="col s12 m12 l6 xl5"><span class="bold">Zip+4:</span> {{contactInfo?.zip4}}</div>
                <div class="col s12 m12 l6 xl5 left-padding-0"><span class="bold">Phone No:</span>
                    {{contactInfo?.phoneNo}}</div>
                <div class="col s12 m12 l6 xl5"><span class="bold">Work Email:</span> {{contactInfo?.workEmail}}</div>
                <div class="col s12 m12 l6 xl5 left-padding-0"><span class="bold">Personal Email:</span>
                    {{contactInfo?.personalEmail}}</div>
            </div>

        </div>
    </div>
</div>
<div class="k-icon k-i-loading outer" *ngIf="dataLoading"></div>